import { gql } from '@apollo/client';

export const CreditAgreementDocumentMetadataFields = gql`
  fragment CreditAgreementDocumentMetadataFields on CreditAgreementMetadata {
    id
    facilityType
    creditFacilityId
    effectiveFrom
    effectiveTo
    version
    _schemaVersion_
    # @deprecated - free to remove @markhaghani
    s3Path
    _note_
    displayName
  }
`;

export const CreditAgreementFullArtifactFields = gql`
  fragment CreditAgreementFullArtifactFields on CreditAgreementFullArtifact {
    id
    creditAgreement
  }
`;

// ========== QUERIES ==========

export const GET_IMPLEMENTATIONS = gql`
  query implementations($organizationId: UUID!) {
    organization(organizationId: $organizationId) {
      implementations {
        id
        name
        creditFacilities {
          id
        }
      }
    }
  }
`;

export const GET_CREDIT_AGREEMENT_DOCUMENTS_METADATA = gql`
  ${CreditAgreementDocumentMetadataFields}
  query GetCreditAgreementDocumentsMetadata($creditFacilityId: UUID!) {
    creditAgreementDocumentsMetadata(creditFacilityId: $creditFacilityId) {
      ...CreditAgreementDocumentMetadataFields
    }
  }
`;

export const GET_CREDIT_AGREEMENT_FULL_ARTIFACT = gql`
  ${CreditAgreementFullArtifactFields}
  query GetCreditAgreementFullArtifact($creditAgreementId: UUID!) {
    creditAgreementFullArtifact(creditAgreementId: $creditAgreementId) {
      ...CreditAgreementFullArtifactFields
    }
  }
`;

export const CREATE_IMPLEMENTATION = gql`
  mutation createImplementation(
    $ownerOrganizationId: UUID!
    $implementationName: String!
    $borrowerId: UUID!
  ) {
    createImplementation(
      ownerOrganizationId: $ownerOrganizationId
      implementationName: $implementationName
      borrowerId: $borrowerId
    ) {
      id
    }
  }
`;

export const CREATE_SINGLE_FACILITY_IMPLEMENTATION = gql`
  mutation createSingleFacilityImplementation(
    $ownerOrganizationId: UUID!
    $creditFacilityName: String!
    $creditFacilityParties: [PartyInput!]!
  ) {
    createSingleFacilityImplementation(
      ownerOrganizationId: $ownerOrganizationId
      creditFacilityName: $creditFacilityName
      creditFacilityParties: $creditFacilityParties
    ) {
      id
    }
  }
`;

export const GET_VISIBLE_ORGANIZATIONS = gql`
  query visibleOrganizations($organizationId: UUID!) {
    organization(organizationId: $organizationId) {
      visibleOrganizations {
        id
        slug
        name
      }
    }
  }
`;

export const GET_CREDIT_AGREEMENT_FULL_ARTIFACT_IMPLEMENTATION_PORTAL_WIP = gql`
  ${CreditAgreementFullArtifactFields}
  query GetCreditAgreementFullArtifactImplementationPortalWip(
    $creditFacilityId: UUID!
  ) {
    creditAgreementFullArtifactWip(creditFacilityId: $creditFacilityId) {
      wip {
        ...CreditAgreementFullArtifactFields
      }
      errors
    }
  }
`;

export const UPDATE_CLIENT_CREDIT_AGREEMENT_FULL_ARTIFACT_IMPLEMENTATION_PORTAL_WIP = gql`
  mutation UpdateClientCreditAgreementFullArtifactImplementationPortalWip(
    $creditAgreementFullArtifactWip: CreditAgreementFullArtifactInput!
  ) {
    updateClientCreditAgreementFullArtifactImplementationPortalWip(
      creditAgreementFullArtifactWip: $creditAgreementFullArtifactWip
    ) {
      response
    }
  }
`;

export const COMMIT_ARTIFACT_DOCUMENT_AND_CREDIT_AGREEMENTS = gql`
  mutation commitArtifactDocumentAndCreditAgreements($creditFacilityId: UUID!) {
    commitArtifactDocumentAndCreditAgreements(
      creditFacilityId: $creditFacilityId
    ) {
      successes
      errors
    }
  }
`;

export const UPDATE_CREDIT_AGREEMENT_DISPLAY_NAME = gql`
  mutation updateCreditAgreementDisplayName(
    $creditAgreementId: UUID!
    $displayName: String!
  ) {
    updateCreditAgreementDisplayName(
      creditAgreementId: $creditAgreementId
      displayName: $displayName
    ) {
      response
    }
  }
`;
